import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { SecurityService } from 'app/security/security.service';
import { UserModel } from './../shared/models/user-info.model';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
@Injectable()
export class LaunchResolver implements Resolve<UserModel> {

    constructor(private securityService: SecurityService,
        private authService: AuthService,
        private router: Router) { }

    resolve(activatedRoute: ActivatedRouteSnapshot) {
        if (this.authService.isAuthenticated())
            this.securityService.logout();
        try {
            let enrolleeId: number = parseInt(decodeURIComponent(atob(activatedRoute.paramMap.get('enrollee')))),
                key: string = activatedRoute.paramMap.get('token');
            return this.securityService.launch(enrolleeId, key).do(() => {
                this.router.navigate(['stages']);
            }).catch((e) => {
                this.authService.toastr.error('Server side error in launching enrollee.Please contact server admin.');
                return Observable.of(e);
            });
        } catch (error) {
            this.authService.toastr.error('Cannot proccess launch parameters');
            return Observable.of(null);
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/auth/launch.resolver.ts